const osspath = 'https://kindstar-youyi.oss-cn-shanghai.aliyuncs.com/'

export default osspath
